import styled, { css } from "styled-components";
import { containerCss } from "../../styles/media";
import {
  flexHelpers,
  marginHelpers,
  paddingHelpers,
} from "../../styles/positioning";

const Div = styled.div`
  ${flexHelpers} width: 100%;

  ${({ textCenter }) =>
    textCenter
      ? css`
          text-align: center;
        `
      : ""} ${containerCss};
  ${marginHelpers};
  ${paddingHelpers};
`;

Div.displayName = "Div";

// eslint-disable-next-line
export default Div;
